import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <div className="Footer mt-14 h-14 w-full text-center">
      @Developed by ASE Group 6. All rights reserved
    </div>
  );
}

export default Footer;
